import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseView } from '../../../base-view';
import { TareasApiService } from '../../../../service/api/tareas-api.service';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { Filtering } from '../../../../service/filtering/filtering';
import { environment } from '../../../../../environments/environment';
import { ControlSanitarioModel } from '../../../../models/tareas/control-sanitario.model';
import { ColInterface } from '../../../../common/components/common-list-table/col.interface';
import { ColStylesInterface } from '../../../../common/components/common-list-table/col-styles.interface';
import { ControlSanitarioFormDefinition } from './control-sanitario-form/form-control/form-definition';
import { FormType } from '../../../../common/components/reactive-form-builder/interfaces/form.interface';

@Component({
    selector: 'app-control-sanitario',
    standalone: false,
    templateUrl: './control-sanitario.component.html',
    styleUrls: ['./control-sanitario.component.scss']
})
export class ControlSanitarioComponent extends BaseView<ControlSanitarioModel> implements OnInit {
    public form: ControlSanitarioFormDefinition | null = null;
    public getRequest: RequestHandler<ControlSanitarioModel[]> = this.tareasApi.controlSanitario.GET;
    public deleteRequest: RequestHandler<ControlSanitarioModel> = this.tareasApi.controlSanitario.DELETE;

    public override filtering: Filtering<ControlSanitarioModel> = new Filtering<ControlSanitarioModel>();
    public showTareasFincas = environment.features.showTareasFincas;
    public fincaName = environment.features.fincaName;
    public serverUrl = environment.serverUrl;

    public override canShow: Record<string, boolean> = {};
    public override model: ControlSanitarioModel = {};

    public cols: ColInterface[] = [
        { field: 'id', header: 'Nº\xa0Ficha', filter: '' },
        { field: 'finca', header: this.fincaName, filter: '', visible: this.showTareasFincas },
        { field: 'fecha_inicio', header: 'F.\xa0Inicio', filter: '' },
        { field: 'fecha_fin', header: 'F.\xa0Fin', filter: '' },
        { field: 'fecha_plazo', header: 'Plazo\xa0seg.', filter: '' },
        { field: 'tipo_tratamiento', header: 'T.Tratam.', filter: '' },
        { field: 'veterinario', header: 'Veterinario', filter: '' },
        { field: 'diagnostico', header: 'Diagnóstico', filter: '' },
        { field: 'producto', header: 'Producto', filter: '' },
        { field: 'animales_tratados', header: 'Animal\xa0tratado', filter: '' },
    ];

    constructor(
        public tareasApi: TareasApiService,
        private readonly dashboardEvents: DashboardService,
        private readonly router: Router,
    ) {
        super(
            dashboardEvents,
            tareasApi.controlSanitario.GET,
            tareasApi.controlSanitario.DELETE,
        );
    }

    public ngOnInit(): void {
        this.dashboardEvents.setSubmenuItem('tareas', 'control-sanitario');
    }

    public globalVisualTransform(value: string): string {
        return value;
    }

    public globalConditionalStyle(): ColStylesInterface {
        return {};
    }

    public add(): void {
        this.router.navigate(['dashboard', 'control-crear-sanitario']);
    }

    public edit(data: ControlSanitarioModel): void {
        this.router.navigate(['dashboard', 'control-editar-sanitario', data.id]);
    }

    public duplicate(data: ControlSanitarioModel): void {
        this.router.navigate(['dashboard', 'control-duplicar-sanitario', data.id]);
    }

    public override show(modal: string, data: ControlSanitarioModel): void {
        super.show(modal, data);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;

        this.form = new ControlSanitarioFormDefinition(formType, data);
    }
}
